import { watch } from 'vue'
import { useSiteConfigStore } from '../siteConfig'

export default function SiteTitleWatcherPlugin({ store }) {
  // Only watch the siteConfig store
  if (store.$id === 'siteConfig') {
    const siteConfigStore = useSiteConfigStore()

    watch(
      () => siteConfigStore.config,
      (newConfig) => {
        if (newConfig && newConfig.site_title) {
          document.title = newConfig.site_title
        }
      }
    )
  }
}
